export const LAWLEX_STATUS_TRUE = 1;
export const LAWLEX_STATUS_FALSE = 0;
export const LAWLEX_API_NOT_CALLED = 2;